import { transport } from 'config/transport';

export function callApiSaveDuChiCaNhan(congDoanId, body) {
    return transport.post(`/congdoan/${congDoanId}/nun/duchi`, body);
}
